import DownloadAppButton from './DownloadAppButton';
import NotificationButton from './NotificationsDropdown';
import PostOfferButton from './PostOfferButton';
import UserProfileButton from './UserProfileDropdown';
import WishlistButton from './WishlistButton';

const NavigationRight = ({ gaEventCategory }) => (
  <nav className="relative top-4 flex 2xl:gap-2">
    <DownloadAppButton gaEventCategory={gaEventCategory} />
    <PostOfferButton gaEventCategory={gaEventCategory} />
    <WishlistButton gaEventCategory={gaEventCategory} />
    <NotificationButton gaEventCategory={gaEventCategory} />
    <UserProfileButton gaEventCategory={gaEventCategory} />
  </nav>
);

export default NavigationRight;
